export function alphanumericSort(a: string, b: string, ascending?: boolean) {
  const valueA = a;
  const valueB = b;

  const valueGoingUp = ascending ? -1 : 1;
  const valueGoingDown = ascending ? 1 : -1;

  const regex = /^(\d+)/;
  const aMatch = valueA.match(regex);
  const bMatch = valueB.match(regex);

  if (aMatch && bMatch) {
    const aNum = parseInt(aMatch[1], 10);
    const bNum = parseInt(bMatch[1], 10);
    if (aNum > bNum) {
      return valueGoingUp;
    }
    if (aNum < bNum) {
      return valueGoingDown;
    }
  } else if (aMatch) {
    return valueGoingUp; // a has leading numbers, so it comes first
  } else if (bMatch) {
    return valueGoingDown; // b has leading numbers, so it comes first
  }

  // If no numbers or numbers are equal, sort alphabetically
  if (valueA.localeCompare(valueB) > 0) {
    return valueGoingUp;
  }
  return valueGoingDown;
}
